import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, useTheme } from '@mui/material';

import { useDirection } from '@/hooks/useDirection';
import { borders } from '@/theme/constants';
import typography from '@/theme/typography';

interface AddQuestionButtonProps {
  onAddQuestion: () => void;
}

const AddQuestionButton: FC<AddQuestionButtonProps> = ({ onAddQuestion }) => {
  const { applyDirectionalStyles } = useDirection();
  const { spacing } = useTheme();
  const { t } = useTranslation('settings');

  return (
    <Button
      onClick={onAddQuestion}
      className="AddQuestionButton-root"
      sx={{
        border: borders.default,
        borderColor: 'primary.main',
        py: spacing(0.5),
        ...typography.body3,
        fontWeight: typography.fontWeightMedium,
        '& .MuiButton-endIcon': applyDirectionalStyles(1, 0, 'ml', 'mr')
      }}
    >
      {t('orgSettings.talentRegistrationForm.addQuestion')}
    </Button>
  );
};

export default AddQuestionButton;
